import Vue from 'vue'

import '@babel/polyfill'
import '@fortawesome/fontawesome-pro/css/all.css'
import 'vue-croppa/dist/vue-croppa.css'

import '@/plugins/vuetify'
import App from '@/App.vue'
import Vuelidate from 'vuelidate'
import ptrAnimatesMaterial2 from 'mobile-pull-to-refresh/dist/styles/material2/animates'
import 'mobile-pull-to-refresh/dist/styles/material2/style.css'
// import firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/auth'        // for authentication
import 'firebase/storage'     // for storage
import 'firebase/firestore'   // for cloud firestore
import 'firebase/functions'   // for cloud functions
// import 'firebase/database'    // for realtime database
// import 'firebase/messaging'   // for cloud messaging

import Croppa from 'vue-croppa'
import VueAnalytics from 'vue-analytics'
// import axios from 'axios'
import infiniteScroll from 'vue-infinite-scroll'

import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'


import router from '@/router'
import store from '@/store/store'

import { sync } from 'vuex-router-sync'


import { date, dateLong, dateShort, dateComplete, time } from '@/components/filters_pipes/date/date'

import AlertCmp from '@/components/global_comps/Alert'
import SuccessCmp from '@/components/global_comps/Success'



const isProd = process.env.NODE_ENV === 'production'

Vue.use(ptrAnimatesMaterial2)
Vue.use(Datetime)
Vue.use(Vuelidate)
Vue.use(Croppa)
Vue.use(VueAnalytics,  {
  id: 'UA-139711360-1',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})
Vue.use(infiniteScroll)



Vue.filter('dateComplete', dateComplete)
Vue.filter('date', date)
Vue.filter('dateShort', dateShort)
Vue.filter('dateLong', dateLong)
Vue.filter('time', time)

Vue.component('app-alert', AlertCmp)
Vue.component('app-success', SuccessCmp)
Vue.component('datetime', Datetime)

Vue.config.productionTip = false

// eslint-disable-next-line
// const unsync = sync(store, router) 
sync(store, router)

new Vue({
  router,
  store,
  created() {
    store.commit('setRefreshLoading', true)
    // init Firebase
    firebase.initializeApp({
      apiKey:             process.env.VUE_APP_GOOGLE_FIREBASE_API_KEY,
      authDomain:         process.env.VUE_APP_GOOGLE_FIREBASE_AUTH_DOMAIN,
      databaseURL:        process.env.VUE_APP_GOOGLE_FIREBASE_DATABASE_URL,
      projectId:          process.env.VUE_APP_GOOGLE_FIREBASE_PROJECT_ID,
      storageBucket:      process.env.VUE_APP_GOOGLE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId:  process.env.VUE_APP_GOOGLE_FIREBASE_MESSAGING_SENDER_ID,
      appId:              process.env.VUE_APP_GOOGLE_FIREBASE_APP_ID
    })

    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(function() {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        // return firebase.auth().signInWithEmailAndPassword(email, password)
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code
        console.log('errorCode', errorCode)
        var errorMessage = error.message
        console.log('errorMessage', errorMessage)

      })


    // auto SignIn if Token is available
    firebase.auth().onAuthStateChanged((user) => {

      console.log('--------------onAuthStateChanged--------------')
      if (user) {
        // console.log('auth', firebase.auth())
        console.log('MainJS_OnAuthStateChanged_UserIsLoggedIn->AutoLogin', user)
        store.dispatch('autoSignIn', user)
      } else {
        // console.log('noauth', firebase.auth())
        store.commit('setLoading', false)
        // console.log('bla', store.state.user)
        // if (store.state.user.isNotVerified === null) {
        //   store.commit('setPleaseVerifyMail', true)
        // }
        console.log('MainJS_OnAuthStateChanged_UserNotLoggedIn->LoginScreen')
        // router.push('/')
        store.commit('setRefreshLoading', false)
      }
      
    })

    // refresh Page after one hour when user === null
    let reloadEveryHour = function (){
      setInterval(function(){ checkUser() },61*60000)
    }
  
    function checkUser()
    {
      console.log('checkUserEveryHour')
      let user = firebase.auth().currentUser
      if (user) {

      } else {
        router.push('/')
      }
      // store.dispatch('logout')
      // oder restoreVuex --> check with every router change if user is not null
      // let user = firebase.auth().currentUser
      
      // if (user) {
      //   console.log(user)
      // } else {
      //   window.location.reload(true)
      // }
    }

    reloadEveryHour()


  },
  render: h => h(App)
}).$mount('#app')
